import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import {
	CarrierDTOResponse,
	IS_NOT_NULL_OR_UNDEFINED,
	IS_NULL_OR_UNDEFINED,
} from 'cargo-chief-commons';

@Component({
	selector: 'app-carrier-selector-dialog-component',
	templateUrl: './carrier-selector-dialog.component.html',
	styleUrls: ['./carrier-selector-dialog.component.scss'],
})
export class CarrierSelectorDialogComponent implements OnInit {
	@Input() label: string = '';
	@Output() carrierSelected: EventEmitter<CarrierDTOResponse> = new EventEmitter();

	constructor(public dialog: MatDialog) {}

	ngOnInit() {}

	openDialog() {
		const dialogRef = this.dialog.open(CarrierSelectorDialog, {
			width: '450px',
		});
		dialogRef.afterClosed().subscribe((result) => {
			this.carrierSelected.emit(result);
		});
	}
}

@Component({
	selector: 'app-carrier-selector-dialog',
	templateUrl: 'modal.html',
})
export class CarrierSelectorDialog {
	selectedCarrier: any = null;

	IS_NULL_OR_UNDEFINED = IS_NULL_OR_UNDEFINED;
	IS_NOT_NULL_OR_UNDEFINED = IS_NOT_NULL_OR_UNDEFINED;

	constructor(public dialogRef: MatDialogRef<CarrierSelectorDialog>) {}

	closeDialog(data: any): void {
		this.dialogRef.close(data);
	}
}
